
































































import { Vue, Component, Mixins, Prop } from "vue-property-decorator";
import _ from "lodash";
import moment from "moment";
import MyList from "@/mixins/list";

import Add from "./block_add.vue";
import Edit from "./block_edit.vue";

@Component({
  components: {
    Add,
    Edit,
  },
})
export default class extends Mixins(MyList) {
  @Prop() stadiumId!: number;

  @Prop() grounds!: any[];

  dispatchType = "stadium/getBlocks";

  dispatchTypeDelete = "stadium/deleteBlock";

  deleteConfirmContent = "确定要删除该包场吗？";

  columns: any[] = [
    { title: "编号", dataIndex: "id" },
    { title: "客户名称", dataIndex: "customer" },
    { title: "绑定手机号", dataIndex: "mobile" },
    { title: "包场信息", scopedSlots: { customRender: "info" } },
    { title: "状态", scopedSlots: { customRender: "status" } },
    { title: "操作", scopedSlots: { customRender: "action" } },
  ];

  renderWeek(week: any) {
    // console.log(typeof week)
    const obj: any = _.find(this.weeks, (o) => o.key === Number(week));
    // console.log(obj)
    return `每${obj.name}`;
  }

  renderHour(hour: any) {
    const hour1 = Number(hour);
    if (hour1 < 10) {
      return `0${hour1}:00`;
    }
    return `${hour1}:00`;
  }

  renderInfo(record: any) {
    let weekstr = "";
    let groundstr = "";
    const weekarr: string[] = record.block_weeks.split(",");
    const groundarr: string[] = record.block_grounds.split(",");

    console.log(groundarr);

    for (let i = 0; i < weekarr.length; i++) {
      for (let j = 0; j < this.weeks.length; j++) {
        let w: string = weekarr[i];

        if (this.weeks[j].key == w) {
          weekstr += `每${this.weeks[j].name}、`;
        }
      }
    }

    for (let i = 0; i < groundarr.length; i++) {
      for (let j = 0; j < this.grounds.length; j++) {
        if (this.grounds[j].id == groundarr[i]) {
          groundstr += `${this.grounds[j].name}、`;
        }
      }
    }

    return `${weekstr}<br />${moment({
      h: record.block_clock_start,
      m: record.block_clock_start_min,
    }).format("HH:mm")}-${moment({
      h: record.block_clock_end,
      m: record.block_clock_end_min,
    }).format("HH:mm")}<br />${groundstr}<br />${moment(
      record.effect_time_start
    ).format("YYYY年MM月DD日")}-${moment(record.effect_time_end).format(
      "YYYY年MM月DD日"
    )}`;
  }

  doCancel(id: number, params?: any){
    this.deleteConfirmContent = "确定要取消该包场吗？"
    this.handleDelete(id,{cancel:1})
    this.deleteConfirmContent = "确定要删除该包场吗？"
  }

  mounted() {
    this.loadData({ stadium_id: this.stadiumId }, false);
    console.log(this.grounds);
  }
}
